module.exports = __webpack_public_path__ + "static/2-23bb62cf0469488c83dcdeee0653292b.jpg";